export type FormatPriceOptions = {
	locale: string;
	currency?: string;
	currencyDisplay?: Intl.NumberFormatOptions["currencyDisplay"];
	minimumFractionDigits?: number;
	maximumFractionDigits?: number;
	useGrouping?: boolean;
};

const defaultFractionDigits = 2;

export function formatPrice(
	price: number,
	{
		locale,
		currency,
		currencyDisplay = "code",
		minimumFractionDigits = defaultFractionDigits,
		maximumFractionDigits = defaultFractionDigits,
		useGrouping = true,
	}: FormatPriceOptions,
): string {
	const normalizedCurrency = currency?.trim().toUpperCase();
	const fractionOptions = {
		minimumFractionDigits,
		maximumFractionDigits,
		useGrouping,
	};

	if (normalizedCurrency) {
		try {
			return new Intl.NumberFormat(locale, {
				style: "currency",
				currency: normalizedCurrency,
				currencyDisplay,
				...fractionOptions,
			}).format(price);
		} catch (error) {
			if (!(error instanceof RangeError)) {
				throw error;
			}
		}
	}

	const formattedPrice = new Intl.NumberFormat(locale, fractionOptions).format(
		price,
	);

	return normalizedCurrency
		? `${formattedPrice} ${normalizedCurrency}`
		: formattedPrice;
}
